import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { finalIncludes, images } from '../../data/content';
export function FinalCTA() {
  return <section className="bg-navy-950 px-4 py-16 sm:py-24" aria-labelledby="final-title" data-id="element-170" data-mp="3mu1p5wwgqm83">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-171" data-mp="3rsv5ry71qtch">
        <div data-id="element-172" data-mp="3dt3l5em0yepi">
          <p className="text-sm font-extrabold uppercase tracking-wider text-cta" data-id="element-173" data-mp="3dtby16i5dk0p">
            Ready to organize your critical care nursing studies?
          </p>
          <h2 id="final-title" className="mt-3 text-[30px] font-black leading-[1.08] tracking-tight text-white text-balance sm:text-5xl" data-id="element-174" data-mp="3hskrsbd6thw9">
            Build a more structured approach to critical care concepts.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-mist sm:text-lg" data-id="element-175" data-mp="124krvp2tutwx">
            With six structured volumes and five complementary bonuses, you’ll have a dedicated resource for reviewing
            selected critical care concepts, organizing your study materials, and practicing your reasoning through
            educational cases.
          </p>
          <p className="mt-6 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-176" data-mp="z0xkec6qvrjx">
            Your complete collection includes
          </p>
          <ul className="mt-3 space-y-2.5" data-id="element-177" data-mp="v0n2q29lbcp8">
            {finalIncludes.map(item => <li key={item} className="flex items-center gap-2.5" data-id="element-178" data-mp="7ass7rcqu085">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-navy-950" data-id="element-179" data-mp="2axzrjdbl2kz">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-180" data-mp="gaplk6a2vn9j" />
                </span>
                <span className="text-base font-semibold text-white" data-id="element-181" data-mp="babb6hl0818c">{item}</span>
              </li>)}
          </ul>
        </div>

        <div data-id="element-182" data-mp="1rrpaqt14plzc">
          <img src={images.mockup} alt="Critical Care Nursing Blueprint collection" className="mx-auto w-full max-w-lg" data-id="element-183" data-mp="1mqjisxfam2qv" />
          <div className="mx-auto mt-4 max-w-lg rounded-3xl bg-navy-900 p-5 text-center ring-1 ring-white/10 sm:p-6" data-id="element-184" data-mp="kdn0306j7yj6">
            <p className="text-sm font-bold text-mist" data-id="element-185" data-mp="pb5bqybxoruv">Get the complete Critical Care Nursing Blueprint™ for</p>
            <p className="mt-1 flex items-baseline justify-center gap-2" data-id="element-186" data-mp="tf38x3hp7sla">
              <span className="text-6xl font-black leading-none text-white" data-id="element-187" data-mp="yd4rzof4jrwr">$27</span>
              <span className="text-lg font-bold text-mist" data-id="element-188" data-mp="1n5kzyemh1ga">USD</span>
            </p>
            <p className="mt-1 text-xs font-extrabold uppercase tracking-wider text-brand" data-id="element-189" data-mp="5o7cft2as97p">
              One-time payment · Digital educational product
            </p>
            <CTAButton label="Yes! I want the Critical Care Nursing Blueprint™" className="mt-5" data-id="element-190" data-mp="alze3esqv9p3" />
            <p className="mt-3 text-xs font-medium text-mist sm:text-sm" data-id="element-191" data-mp="ffbpgn8exjzw">
              Digital delivery · No monthly subscription · Seven-day satisfaction guarantee, subject to the published
              refund policy
            </p>
          </div>
        </div>
      </div>
    </section>;
}